
  (function() {
    var form = document.getElementById('pl-main-form');
    if (!form) return;
    var variantId = form.querySelector('[data-pl-variant-id]');
    var priceEl   = form.querySelector('[data-pl-price]');
    var compareEl = form.querySelector('[data-pl-compare]');
    var saveEl    = form.querySelector('[data-pl-save]');
    var atcPrice  = form.querySelector('[data-pl-atc-price]');
    var stickyPrice = document.querySelector('[data-pl-sticky-price]');
    var selected  = form.querySelector('[data-pl-selected]');
    var radios    = form.querySelectorAll('[data-pl-variant-radio]');
    var swatches  = form.querySelectorAll('.pl-main__swatch');

    radios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        if (!radio.checked) return;
        // Update hidden variant ID
        variantId.value = radio.value;
        // Update price
        var newPrice = radio.dataset.plPriceValue;
        if (newPrice && priceEl) priceEl.textContent = newPrice;
        if (newPrice && atcPrice) atcPrice.textContent = newPrice;
        if (newPrice && stickyPrice) stickyPrice.textContent = newPrice;
        // Update selected label
        var title = radio.dataset.plTitle;
        if (title && selected) selected.textContent = title;
        // Update active swatch class
        swatches.forEach(function(v) { v.classList.remove('pl-main__swatch--active'); });
        var parent = radio.closest('.pl-main__swatch');
        if (parent) parent.classList.add('pl-main__swatch--active');

        // ── Change main product image to variant's featured image ──
        var imgIdx = parseInt(radio.dataset.plVariantImageIdx || '-1', 10);
        if (imgIdx >= 0) {
          var scroller = document.querySelector('[data-pl-scroller]');
          var slide = document.querySelector('[data-pl-slide="' + imgIdx + '"]');
          if (scroller && slide) {
            scroller.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          }
          // Also update thumb/dot active states
          document.querySelectorAll('[data-pl-thumb]').forEach(function(t) {
            t.classList.toggle('pl-main__thumb--active', parseInt(t.dataset.plThumb,10) === imgIdx);
          });
          document.querySelectorAll('[data-pl-dot]').forEach(function(d) {
            d.classList.toggle('pl-main__dot--active', parseInt(d.dataset.plDot,10) === imgIdx);
          });
        }
      });
    });

    // ─── Gallery scroll-snap carousel ──────────────────
    var scroller = document.querySelector('[data-pl-scroller]');
    var slides   = document.querySelectorAll('[data-pl-slide]');
    var thumbs   = document.querySelectorAll('[data-pl-thumb]');
    var dots     = document.querySelectorAll('[data-pl-dot]');

    function setActiveIdx(idx) {
      thumbs.forEach(function(t) { t.classList.toggle('pl-main__thumb--active', parseInt(t.dataset.plThumb,10) === idx); });
      dots.forEach(function(d)   { d.classList.toggle('pl-main__dot--active',   parseInt(d.dataset.plDot,10)   === idx); });
    }
    // Click thumb -> scroll to slide
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var idx = parseInt(thumb.dataset.plThumb, 10);
        var slide = slides[idx];
        if (slide && scroller) scroller.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActiveIdx(idx);
      });
    });
    // Scroll -> update active thumb/dot (via IntersectionObserver)
    if (scroller && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            var idx = parseInt(e.target.dataset.plSlide, 10);
            setActiveIdx(idx);
          }
        });
      }, { root: scroller, threshold: [0.6, 0.8, 1] });
      slides.forEach(function(s) { io.observe(s); });
    }

    // ─── Video tile lightbox ─────────────────────────
    var lb = document.querySelector('[data-pl-videolb]');
    var lbFrame = document.querySelector('[data-pl-videolb-frame]');
    var lbCloses = document.querySelectorAll('[data-pl-videolb-close]');
    var videoTiles = document.querySelectorAll('[data-pl-video]');
    var lastFocused = null;

    function openLightbox(tile) {
      if (!lb || !lbFrame) return;
      var type = tile.getAttribute('data-tile-type');
      var videoSrc = tile.getAttribute('data-video-src');
      var imageSrc = tile.getAttribute('data-image-src');
      if (type === 'image' && imageSrc) {
        lbFrame.innerHTML = '<img src="' + imageSrc + '" alt="">';
      } else if (videoSrc) {
        lbFrame.innerHTML = '<video src="' + videoSrc + '" controls autoplay playsinline></video>';
      } else {
        var poster = tile.querySelector('.pl-main__video-poster');
        if (poster) lbFrame.innerHTML = poster.outerHTML;
      }
      lb.hidden = false;
      // Force reflow so the transition kicks in
      void lb.offsetWidth;
      lb.setAttribute('data-pl-open', '');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      lastFocused = tile;
      // Focus the close button for keyboard users
      var closeBtn = lb.querySelector('.pl-videolb__close');
      if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 50);
    }

    function closeLightbox() {
      if (!lb) return;
      lb.removeAttribute('data-pl-open');
      lb.setAttribute('aria-hidden', 'true');
      setTimeout(function() {
        lb.hidden = true;
        if (lbFrame) lbFrame.innerHTML = '';
        document.body.style.overflow = '';
        if (lastFocused) lastFocused.focus();
      }, 260);
    }

    videoTiles.forEach(function(tile) {
      tile.addEventListener('click', function() { openLightbox(tile); });
    });
    lbCloses.forEach(function(el) {
      el.addEventListener('click', closeLightbox);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lb && lb.hasAttribute('data-pl-open')) {
        closeLightbox();
      }
    });

    // ─── Lazy autoplay: only load/play videos when visible ────────
    var autoVideos = document.querySelectorAll('[data-pl-autovideo]');
    if (autoVideos.length && 'IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          var vid = e.target;
          if (e.isIntersecting) {
            if (!vid.src && vid.dataset.src) vid.src = vid.dataset.src;
            var p = vid.play();
            if (p && p.catch) p.catch(function(){ /* autoplay blocked; ignore */ });
          } else {
            vid.pause();
          }
        });
      }, { threshold: 0.25 });
      autoVideos.forEach(function(v){ vio.observe(v); });
    } else {
      // Fallback: just play everything
      autoVideos.forEach(function(v){ var p = v.play(); if (p && p.catch) p.catch(function(){}); });
    }

    // ─── Sticky ATC: show when main ATC scrolls out of view ─────────
    var stickyBar = document.querySelector('[data-pl-sticky-atc]');
    var mainAtc = form.querySelector('.pl-main__atc');
    if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
      var stickyIO = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          var visible = !e.isIntersecting && e.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', visible);
          stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });
      stickyIO.observe(mainAtc);
    }
    var stickySubmit = document.querySelector('[data-pl-sticky-submit]');
    if (stickySubmit) {
      stickySubmit.addEventListener('click', function() {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }

    // ─── Lazy-play videos marked with data-lazy-play ─────────────────
    // Saves MBs on initial load - videos only start loading/playing when
    // scrolled into view. Pauses when out of view to save CPU/battery.
    var lazyVideos = document.querySelectorAll('video[data-lazy-play]');
    if (lazyVideos.length && 'IntersectionObserver' in window) {
      var lpio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          var v = e.target;
          if (e.isIntersecting) {
            if (v.preload !== 'auto') v.preload = 'auto';
            var p = v.play();
            if (p && p.catch) p.catch(function(){});
          } else {
            try { v.pause(); } catch (_) {}
          }
        });
      }, { threshold: 0.2 });
      lazyVideos.forEach(function(v){ lpio.observe(v); });
    }

    // ─── Add-to-Cart: POST then reload with ?drawer=open ────────────────
    // Why reload: this theme has a custom cart-drawer implementation that
    // doesn't follow Dawn's renderContents contract. Reloading with a flag
    // is slower but 100% reliable — drawer renders server-side with item.
    form.addEventListener('submit', function(e) {
      if (form.hasAttribute('data-submitting')) return;
      e.preventDefault();
      form.setAttribute('data-submitting', 'true');

      var atc = form.querySelector('.pl-main__atc');
      var atcLabel = atc ? atc.querySelector('.pl-main__atc-label') : null;
      var originalLabel = atcLabel ? atcLabel.textContent : '';
      if (atcLabel) atcLabel.textContent = 'Adding…';
      if (atc) atc.style.opacity = '.85';

      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
      .then(function(r){ return r.json(); })
      .then(function(data) {
        if (data.status && data.status >= 400) {
          throw new Error(data.description || data.message || 'Add failed');
        }
        // Success - reload with drawer-open hash. Brief success flash first.
        if (atcLabel) atcLabel.textContent = '✓ Added';
        setTimeout(function() {
          window.location.href = window.location.pathname + '?drawer=open';
        }, 350);
      })
      .catch(function(err) {
        console.error('[Forge] ATC error:', err);
        if (atcLabel) atcLabel.textContent = 'Try again';
        if (atc) atc.style.opacity = '';
        setTimeout(function() {
          if (atcLabel) atcLabel.textContent = originalLabel;
          form.removeAttribute('data-submitting');
        }, 1500);
      });
    });

    // ─── On load: if ?drawer=open, auto-open the cart drawer ────────
    if (/[?&]drawer=open/.test(window.location.search)) {
      // Strip the param from the URL so back-button works cleanly
      try { history.replaceState({}, '', window.location.pathname); } catch (_) {}
      // Wait a beat for theme JS to fully wire up the drawer
      setTimeout(function() {
        var drawers = document.querySelectorAll('cart-drawer');
        var primary = null;
        drawers.forEach(function(d) { if (!primary && d.offsetParent !== null) primary = d; });
        primary = primary || drawers[0];
        if (primary) {
          if (typeof primary.open === 'function') {
            primary.open();
          } else {
            // Fallback: click the cart icon to trigger theme's own drawer toggle
            var cartIcon = document.querySelector('a[href="/cart"], [href*="/cart"]');
            if (cartIcon) cartIcon.click();
          }
        }
      }, 300);
    }
  })();
